export const APP_FONT_FAMILY = "'Outfit', 'Segoe UI', system-ui, sans-serif";

export const COLORS = {
  white: "#fff",
  textPrimary: "#101828",
  textSecondary: "#475467",
  textMuted: "#98a2b3",
  border: "#e4e7ec",
  primary: "#101828",
  primarySoft: "#667085",
  primaryAccent: "#465fff",
  backgroundApp: "#f9fafb",
};

export const RADIUS = {
  sm: 4,
  md: 6,
  lg: 8,
  xl: 10,
  pill: 99,
};

export const SPACING = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
};
